import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getMessaging } from "firebase/messaging"; // <-- precisa adicionar isso


const firebaseConfig = {
    apiKey: "AIzaSyCLcorgvAHfrNNFIud5iNpu3qsUtblrdHg",
    authDomain: "solicitacaodeatendimento-988f8.firebaseapp.com",
    projectId: "solicitacaodeatendimento-988f8",
    storageBucket: "solicitacaodeatendimento-988f8.firebasestorage.app",
    messagingSenderId: "371565772266",
    appId: "1:371565772266:web:87cc8a555ff8880adc0693",
    measurementId: "G-8MMVR37840"
  };
  
  const app = initializeApp(firebaseConfig);

  const db = getFirestore(app);
  const messaging = getMessaging(app); // <-- e inicializar aqui também
  
  export { db, messaging }; // <-- exportar os dois